<mat-card>
  <div class="published">
    <div>
      Published by {{ item.userCreatedName }} on
      {{ item.publicationDate | date: "d MMM y, HH:mm" }}
    </div>
    <div class="spacer"></div>

    <div *ngIf="!readonly" class="actions-container">
      <button *ngIf="(canEditNewsItem$ | async) && !item.hide" mat-icon-button data-prot="button_hide" color="primary" (click)="toggleHidden()" matTooltip="News Item is visible. Click to hide.">
        <mat-icon>visibility</mat-icon>
      </button>
      <button *ngIf="(canEditNewsItem$ | async) && item.hide" mat-icon-button data-prot="button_show" color="primary" (click)="toggleHidden()" matTooltip="News Item is hidden. Click to show.">
        <mat-icon>visibility_off</mat-icon>
      </button>
      <button *ngIf="canEditNewsItem$ | async" mat-icon-button class="nofocus" color="primary" (click)="editNewsItem()" matTooltip="Edit News Item">
        <mat-icon>create</mat-icon>
      </button>
      <button *ngIf="(canEditNewsItem$ | async) && item.hide" mat-icon-button data-prot="button_delete" color="primary" (click)="deleteNewsItem()" matTooltip="Permanently delete News Item">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </div>

  <mat-card-title
    ><b>{{ item.title }}</b></mat-card-title
  >
  <br />
  <div mat-card-content>
    <div [innerHTML]="item.content"></div>
  </div>

  <div class="footer" *ngIf="!readonly">
    <hr />
    <div>Expiration date: {{ item.expirationDate | date: "d MMM y" }}</div>
    <section class="forSection">
      <mat-checkbox [checked]="item.forInternal" disabled labelPosition="after">Internal</mat-checkbox>
      <mat-checkbox [checked]="item.forCenter" disabled labelPosition="after">Centers</mat-checkbox>
      <mat-checkbox [checked]="item.forLab" disabled labelPosition="after">Laboratories</mat-checkbox>
    </section>
  </div>
</mat-card>
